import React from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PropTypes from 'prop-types';


const TemporaryConversationExpiryMessage = ({ message }) => (
  <li className="message">
    <div className="calendar-notification-message-container">
      <div className="calendar-notification-message-header">
        <CalendarTodayIcon />
        <span className="calendar-notification-message-title">
          24-Hour Expiry Reminder
        </span>
      </div>
      <p>{message.message}</p>
    </div>
  </li>
);

export default TemporaryConversationExpiryMessage;

TemporaryConversationExpiryMessage.propTypes = { message: PropTypes.string.isRequired };
